export enum DashboardProviderApiKeyErrorCode {
  PROVIDER_KEY_REQUIRED = "DASHBOARD_PROVIDER_API_KEY_REQUIRED",
}

export interface DashboardApiKeyHttpError {
  message: string;
  error_code: string;
  provider?: string;
  workflow_node_id?: string | number | null;
}

export const isDashboardApiKeyHttpError = (value: unknown): value is DashboardApiKeyHttpError => {
  if (!value || typeof value !== "object") {
    return false;
  }
  if (!("error_code" in value) || typeof value.error_code !== "string") {
    return false;
  }
  if (!("message" in value) || typeof value.message !== "string") {
    return false;
  }
  return true;
};
